export const pceftposDefaults = {
  Port: '10103',
  IP: 'localhost',
  tcpipDevicePort: '2050',
};

export const pceftposFields = {
  tcpipDevicePort: {
    id: 'tcpipDevicePort',
    title: 'PC-Eftpos Client Port',
    type: 'text',
    validate: (val) => {
      if (val?.length) {
        return val.match(/[^\d]/g)?.length ? 'Invalid Device Port' : null;
      }
      return 'Device Port is required.';
    },
  },
};
